import { combineReducers } from "redux";

import Settings from "./Settings";
import Auth from "./Auth";

export default combineReducers(
    Object.assign(
        {},
        {},
        {
            Settings,
            Auth
        }
    )
);
